import { styled } from '@mui/material/styles'
import IconButton from '@mui/material/IconButton'

const StyledIconButton = styled(IconButton)(({ theme }) => ({
  color: 'white',
  '&:hover': {
    backgroundColor: theme.palette.primary.dark,
  },
}))

export default StyledIconButton
